<template>
  <div class="samples-list_container has-batch samples-list-view">
    <modal
      ref="batchDetails"
      template="neutral"
      ref-name="batchDetails"
      :close-button-enabled="true"
      :icon-enabled="false"
      title="Detalhes do Lote"
    >
      <spinner v-if="batchLoading" />

      <p v-else-if="batchNotFound">
        Ops! Não foi possível exibir informações do lote.
      </p>

      <div v-else>
        <batch-card
          :batch="batch"
          :is-details-mode="true"
          :eye-icon-visible="false"
          :buttons-visible="false"
        />

        <md-button
          :id="'btnOpenCardDetails'"
          class="btn btn-nonenary"
          @click="pushToBatchDetail(batch)"
        >
          <svg-loader src="/static/images/icon-open-printed-batch.svg" />

          VISUALIZAR LOTE
        </md-button>
      </div>
    </modal>

    <div class="apoio-datatable-wrapper">
      <div class="apoio-datatable-header">
        <div class="local-search">
          <md-input-container
            v-if="samples?.length"
            class="local-search-input-container"
          >
            <md-input
              v-model="query"
              class="local-search-input"
              placeholder="Buscar por..."
            />

            <md-icon
              md-src="/static/images/icon-search-purple.svg"
              class="local-search-input-icon"
            />
          </md-input-container>
        </div>

        <batch-samples
          ref="batchSamples"
          @requestSamplesListUpdate="handleRequestSamplesListUpdate"
        />
      </div>

      <table class="apoio-datatable data-table-header">
        <colgroup>
          <col class="column-check">

          <col class="column-date">

          <col class="column-os">

          <col class="column-patient">

          <col class="column-material">

          <col class="column-batch">

          <col class="column-status">

          <col class="column-origin">

          <col class="column-info">

          <col class="column-expander">
        </colgroup>

        <thead>
          <tr>
            <th class="column-check">
              <div class="styled-checkbox">
                <input
                  id="chkSamplesSelectAll"
                  v-model="selectAll"
                  type="checkbox"
                >

                <label for="chkSamplesSelectAll" />
              </div>

              <md-tooltip
                md-delay="400"
                md-direction="right"
              >
                Selecionar todos
              </md-tooltip>
            </th>

            <th
              title="DATA"
              class="sort-column"
              @click.prevent="sortColumn('date')"
            >
              Data
              <sort-column id="date" />
            </th>

            <th @click.prevent="sortColumn('os_lis')">
              <span
                v-if="!toggle.covax"
                title="OS Alvaro / Lis"
                class="sort-column"
              >OS Alvaro / Lis</span>

              <span
                v-else
                title="REQUISITION NUMBER"
                class="sort-column covax-label"
              >REQUISITION NUMBER</span>

              <md-icon
                v-if="!toggle.covax"
                class="icon-status-info"
                @click.stop.prevent
              >
                info_outline
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Número da Ordem de Serviço do sistema do cliente
                </md-tooltip>
              </md-icon>

              <sort-column
                id="os_lis"
                @click.prevent="sortColumn('os_lis')"
              />
            </th>

            <th
              title="PACIENTE (ID LIS)"
              class="sort-column"
              @click.prevent="sortColumn('patient_name')"
            >
              Paciente (ID Lis)
              <sort-column id="patient_name" />
            </th>

            <th
              class="material"
              @click.prevent="sortColumn('material_description')"
            >
              <span
                title="MATERIAL (ACOND)"
                class="sort-column"
              >Material (Acond)</span>

              <md-icon
                class="icon-status-info"
                @click.stop.prevent
              >
                info_outline
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  <ul>
                    <li>Material e Acondicionamento</li>

                    <li>A = Ambiente</li>

                    <li>R = Refrigerado</li>

                    <li>C = Congelado</li>

                    <li>S = Refrigerado Seco</li>
                  </ul>
                </md-tooltip>
              </md-icon>

              <sort-column
                id="material_description"
                @click.prevent="sortColumn('os_lis')"
              />
            </th>

            <th
              title="LOTE"
              class="sort-column"
              @click.prevent="sortColumn('batch_label')"
            >
              Lote
              <sort-column id="batch_label" />
            </th>

            <th
              class="column-narrow sort-column status"
              @click.prevent="sortColumn('status')"
            >
              Status
              <sort-column id="status" />

              <md-icon
                class="icon-status-info"
                @click.stop.prevent
              >
                info_outline
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Status da Amostra
                </md-tooltip>
              </md-icon>
            </th>

            <th>Origem</th>

            <th>Info</th>

            <th />
          </tr>
        </thead>
      </table>

      <th />

      <table class="apoio-datatable">
        <colgroup>
          <col class="column-check">

          <col class="column-date">

          <col class="column-os">

          <col class="column-patient">

          <col class="column-material">

          <col class="column-batch">

          <col class="column-status">

          <col class="column-origin">

          <col class="column-info">

          <col class="column-expander">
        </colgroup>

        <template>
          <tbody
            v-for="(sample, rowIndex) in filteredSamples"
            :key="rowIndex"
            :md-item="sample"
          >
            <tr
              :class="{
                expanded: sample.expanded
              }"
              class="apoio-datatable__line"
            >
              <!-- Checkbox -->
              <td class="column-check">
                <div class="styled-checkbox">
                  <input
                    :id="'chk' + sampleId(sample)"
                    v-model="selected"
                    type="checkbox"
                    :value="sampleId(sample)"
                    :disabled="sample.status === SampleStatus.Batching"
                  >

                  <label
                    class="list-checkbox"
                    :for="'chk' + sampleId(sample)"
                  />
                </div>
              </td>

              <!-- Date -->
              <td @click.prevent="toggleSampleDetails(rowIndex)">
                <span
                  :title="format(sample.date)"
                  class="os-date-span"
                >{{ format(sample.date) }}</span>
              </td>

              <!-- OS -->
              <td @click.prevent="toggleSampleDetails(rowIndex)">
                <router-link
                  :to="getSampleOSRoute(sample)"
                  @click.stop
                  class="column-os-content"
                >
                  <span>{{ getSampleOSLabel(sample) }}</span>
                </router-link>
              </td>

              <!-- Patient -->
              <td @click.prevent="toggleSampleDetails(rowIndex)">
                <span
                  :title="concatNameCode(sample.patient_name, sample.patient_id_lis)"
                  class="patient-name-span"
                >
                  {{ concatNameCode(sample.patient_name, sample.patient_id_lis) }}
                </span>
              </td>

              <!-- Material -->
              <td @click.prevent="toggleSampleDetails(rowIndex)">
                <div class="column-material-content">
                  <span
                    v-if="packingData(sample)"
                    class="packaging-icon"
                    :class="packingData(sample).color"
                  >
                    <svg-loader :src="`/static/images/icon-${packingData(sample).state}.svg`" />

                    <md-tooltip
                      md-delay="100"
                      md-direction="bottom"
                    >
                      {{ packingData(sample).name }}
                    </md-tooltip>
                  </span>

                  <span
                    v-else
                    class="packaging-icon"
                  >
                    <svg-loader
                      class="icon-rounded background-color-darken-gray"
                      src="/static/images/state-pending-transmission.svg"
                    >Outros</svg-loader>

                    <md-tooltip
                      md-delay="100"
                      md-direction="bottom"
                    >Outros</md-tooltip>
                  </span>

                  <span
                    class="text-wrapper"
                    :title="concatNameCode(sample.material_description, sample.material_packaging)"
                  >
                    {{ sample.material_description }}
                  </span>
                </div>
              </td>

              <!-- Batch -->
              <td @click.prevent="openBatchDetails(sample)">
                <div
                  v-if="sample.batch_label"
                  class="column-batch-content"
                >
                  <div
                    :class="{
                      'batch-urgent': hasUrgent(sample.exams)
                    }"
                  >
                    <span class="column-batch-content-link">{{ sample.batch_label }}</span>

                    <svg-loader src="/static/images/icon-urgent-fast.svg" />

                    <md-tooltip>{{ changePopUp(sample.batch_label, sample.exams) }}</md-tooltip>
                  </div>

                  <span
                    :title="format(sample.batch_date)"
                    class="batch-date"
                  >{{ format(sample.batch_date) }}</span>
                </div>
              </td>

              <!-- Status -->
              <td
                :class="{
                  'status-fail': sample.status === SampleStatus.Fail
                }"
                @click.prevent="toggleSampleDetails(rowIndex)"
              >
                {{ getSampleStatusLabel(sample) }}
              </td>

              <!-- Origin -->
              <td @click.prevent="toggleSampleDetails(rowIndex)">
                {{ sample.origem }}
              </td>

              <!-- Info -->
              <td @click.prevent="toggleSampleDetails(rowIndex)">
                <div
                  v-if="findPendingIssues(sample)"
                  :title="findPendingIssues(sample)"
                >
                  <svg-loader src="/static/images/icon-warning.svg" />
                </div>
              </td>

              <!-- Expander -->
              <td @click.prevent="toggleSampleDetails(rowIndex)">
                <div class="column-expander-content">
                  <svg-loader
                    src="/static/images/arrow-up-primary-color.svg"
                    class="column-expander-content-icon"
                    :class="{
                      'column-expander-content-icon-open': openSamplesDetails.includes(rowIndex)
                    }"
                  />

                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Detalhes
                  </md-tooltip>
                </div>
              </td>
            </tr>

            <tr class="row-details">
              <td
                colspan="10"
                class="row-details__container"
              >
                <sample-details
                  :ref="`sampleDetails-${rowIndex}`"
                  :sample="sample"
                  @refresh-samples="clearAllSampleData()"
                  @toggle-visibility="handleToggleVisibility($event, rowIndex)"
                />
              </td>
            </tr>
          </tbody>
        </template>

        <template v-if="filteredSamples.length === 0 && ['STATUS_END', 'STATUS_FAILED'].includes(sampleLoadingStatus)">
          <tbody>
            <tr>
              <td colspan="10" />
            </tr>

            <tr>
              <td colspan="10">
                Sem resultados encontrados.
              </td>
            </tr>

            <tr>
              <td colspan="10" />
            </tr>
          </tbody>
        </template>

        <tfoot
          v-if="sampleLoadingStatus !== 'STATUS_END'"
          class="on-finite"
        >
          <tr>
            <td colspan="10">
              <infinite-loading
                ref="infiniteLoading"
              >
                <span slot="no-more" />

                <span slot="no-results" />

                <span slot="spinner">
                  <spinner />
                </span>
              </infinite-loading>
            </td>
          </tr>

          <tr
            v-if="(totalSamples >= 1000) | hasManyItemsOnList"
            class="on-finite__message-container"
          >
            <td colspan="10">
              <loading-infinite-message
                :break-loading="breakSampleLoading"
                :update-status-count="getTotalSample"
                warning-text="Esta consulta pode conter muitos registros."
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'

import { SAMPLES_SELECTED, eventBus } from '@/api/eventbus'
import batchService from '@/api/batch'

import { formatDate } from '@/utils/date-utils'
import { concatNameAndCode } from '@/utils/string-utils'
import { setSortation } from '@/utils/sort-columns'

import Spinner from '@/components/common/Spinner'
import SortColumn from '@/components/common/SortColumn'
import loadingInfiniteMessage from '@/components/common/LoadingInfiniteMessage'
import BatchCard from '@/components/PrintLabels/Batches/Cards/BatchCard'
import DocumentIcon from '@/components/Documents/Laboratory/Flag'
import SvgLoader from '@/components/common/SvgLoader'

import SampleDetails from './SampleDetails'
import BatchSamples from './BatchSamples'

const SampleStatus = {
  Batched: 0,
  Pending: 1,
  Batching: 2,
  Fail: 3
}

const sampleStatusLabelMap = {
  [SampleStatus.Batched]: 'Loteado',
  [SampleStatus.Pending]: 'Pendente',
  [SampleStatus.Batching]: 'Loteando...',
  [SampleStatus.Fail]: 'Falhou ao lotear'
}

export default {
  name: 'SamplesList',
  components: {
    'infinite-loading': InfiniteLoading,
    Spinner,
    SampleDetails,
    SortColumn,
    'loading-infinite-message': loadingInfiniteMessage,
    BatchCard,
    DocumentIcon,
    SvgLoader,
    BatchSamples
  },
  data() {
    return {
      SampleStatus,
      selected: [],
      columnSortStatusSamples: {
        date: 'asc',
        os_lis: 'asc',
        patient_name: 'asc',
        material_description: 'asc',
        number_alvaro_order: 'asc',
        batch_label: 'asc',
        printed_status: 'asc'
      },
      batch: {},
      batchLoading: true,
      batchNotFound: false,
      query: '',
      openSamplesDetails: []
    }
  },
  computed: {
    ...mapGetters([
      'samples',
      'sampleLoadingStatus',
      'totalSamples',
      'batchesCurrentTab',
      'samplesCurrentTab',
      'profile',
      'toggle'
    ]),
    filteredSamples() {
      if (this.query) {
        return this.samples?.filter(sample => (
          this.getNormalizedStringToCompare(sample.patient_name).includes(this.getNormalizedStringToCompare(this.query)) ||
          this.getNormalizedStringToCompare(sample.number_alvaro_order).includes(this.getNormalizedStringToCompare(this.query)) ||
          this.getNormalizedStringToCompare(sample.os_lis).includes(this.getNormalizedStringToCompare(this.query)) ||
          this.getNormalizedStringToCompare(sample.material_description).includes(this.getNormalizedStringToCompare(this.query)) ||
          this.getNormalizedStringToCompare(sample.batch_label).includes(this.getNormalizedStringToCompare(this.query))
        )) ?? []
      }

      return this.samples ?? []
    },
    selectAll: {
      get() {
        if (this.filteredSamples.length === 0) {
          return false
        }

        return this.filteredSamples ? this.selected.length === this.filteredSamples.length : false
      },
      set(value) {
        const selected = []

        if (value) {
          this.filteredSamples
            .filter(sample => sample.status !== SampleStatus.Batching)
            .forEach(function (samples) {
              const id = samples.sample_id || samples.bar_code

              selected.push(id)
            })
        }

        this.selected = selected
      }
    },
    hasManyItemsOnList() {
      return this.$route.query.startDate !== this.$route.query.endDate
    }
  },
  watch: {
    sampleLoadingStatus(newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          this.setWaitingSampleLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          this.clearAllSampleData()
          this.selected = []
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    },
    selected(newValue) {
      eventBus.$emit(SAMPLES_SELECTED, newValue)
    },
    batchesCurrentTab() {
      this.clearAllSampleData(this.batchesCurrentTab, true)
    },
    filteredSamples() {
      this.openSamplesDetails.forEach(index => {
        this.$refs[`sampleDetails-${index}`]?.[0]?.toggleVisibility?.()
      })

      this.openSamplesDetails = []
    }
  },
  created() {
    eventBus.$on(SAMPLES_SELECTED, (value) => {
      this.selected = value

      this.setSelectedSamples(
        value.map(id => this.samples.find(sample => sample.sample_id === id || sample.bar_code === id))
      )
    })
  },
  beforeDestroy() {
    this.clearAllSampleData()
  },
  methods: {
    ...mapActions([
      'clearAllSampleData',
      'getServiceSampleDetails',
      'deleteSample',
      'setWaitingSampleLoadingStatus',
      'showDetailsSample',
      'sortSampleList',
      'breakSampleLoading',
      'getTotalSample',
      'getServiceSample',
      'setSelectedSamples'
    ]),
    getNormalizedStringToCompare(value) {
      return String(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w\s]/g, '').trim()
    },
    findPendingIssues(sample) {
      let message = null

      const docsPending = !!(sample.docRequired || sample.exam_order?.some(val => val.docRequired))
      const printPending = !sample.printed_status

      if (docsPending && printPending) {
        message = 'Documentação pendente e não impresso'
      } else if (docsPending) {
        message = 'Documentação pendente'
      } else if (printPending) {
        message = 'Não impresso'
      }

      return message
    },
    getSampleOSRoute(sample) {
      const typeOfSearch = sample.os_lis ? 'OL' : 'OA'
      const os = sample.os_lis ?? sample.number_alvaro_order

      return `/traceability/search?q=${os}&typeOfSearch=${typeOfSearch}`
    },
    getSampleOSLabel(sample) {
      if (sample.os_lis && sample.number_alvaro_order) {
        return `${sample.os_lis} / ${sample.number_alvaro_order}`
      } else if (sample.os_lis) {
        return sample.os_lis
      } else if (sample.number_alvaro_order) {
        return sample.number_alvaro_order
      }
    },
    getSampleStatusLabel(sample) {
      return sampleStatusLabelMap[sample.status] ?? 'Indefinido'
    },
    pushToBatchDetail(batch) {
      const batchId = batch.id ?? batch.batchIdentifier;

      this.$router.push({
        path: `/print-tag/batches/${batchId}`,
        query: {
          startDate: this.$route.query.startDate,
          endDate: this.$route.query.endDate,
          packagingType: this.$route.query.packagingType
        }
      })
    },
    packingData(sample) {
      let packingState

      if (sample.material_packaging) {
        packingState = this.$strings.packagingStatus.find(x => x.type === sample.material_packaging)
      } else {
        packingState = this.$strings.packagingStatus.find(x => x.id === sample.packagingId)
      }

      return packingState
    },
    sortColumn(column, columnChild) {
      this.columnSortStatusSamples[column] = setSortation(
        column,
        columnChild,
        this.columnSortStatusSamples,
        this.sortSampleList
      )
      this.pushEventToAnalytics('Ordenação da coluna ' + column)
    },
    format(v) {
      return formatDate(v)
    },
    toggleSampleDetails(index) {
      this.$refs[`sampleDetails-${index}`]?.[0]?.toggleVisibility?.()

      this.pushEventToAnalytics('Abrir detalhes da amostra')
    },
    concatNameCode(name, code) {
      return concatNameAndCode(name, code)
    },
    openBatchDetails(sample) {
      if (sample.batch_identifier) {
        this.batchLoading = true

        this.getBatchDetails({
          id: sample.batch_id || sample.batch_identifier,
          isWs: sample.origem === 'LIS'
        })
        this.$refs.batchDetails?.open()
        this.pushEventToAnalytics(`Visualizar detalhes do lote da amostra (modal) ${this.batchesCurrentTab}`)
      } else {
        this.$refs.batchSamples?.detailSample(sample)
      }
    },
    getBatchDetails(batchId) {
      batchService
        .getBatchDetails(batchId)
        .then(response => {
          this.batch = response.data
          this.batchLoading = false
          if (Object.entries(this.batch).length === 0) {
            this.batchNotFound = true
          } else {
            this.batchNotFound = false
          }
        })
        .catch(() => {
          this.batchLoading = false
          this.batchNotFound = true
        })
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Amostras',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    changePopUp(title, exams) {
      if (this.hasUrgent(exams)) {
        return 'Lote urgente'
      } else {
        return title
      }
    },
    hasUrgent(exams) {
      if (!exams) {
        return false
      }
      const isUrgent = exams.findIndex(val => val.urgent === true)
      if (isUrgent != -1) {
        return true
      }
    },
    sampleId(sample) {
      if (sample.sample_id) return sample.sample_id
      return sample.bar_code
    },
    hasDocument(document) {
      if (this.samplesCurrentTab === 'aol20') {
        return document.docDelivered
      }

      if (this.samplesCurrentTab === 'aolWs') {
        return document.examDocPendingCount > 0 ? false : true
      }
    },
    handleRequestSamplesListUpdate() {
      this.$emit('requestSamplesListUpdate')
    },
    handleToggleVisibility(isVisible, index) {
      if (isVisible) {
        this.openSamplesDetails = [
          ...new Set([
            ...this.openSamplesDetails,
            index
          ])
        ]
      } else {
        this.openSamplesDetails = this.openSamplesDetails.filter(item => item !== index)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.samples-list-view {
  .apoio-datatable {
    margin: 0;

    .sort-icon {
      position: static;
    }

    &-wrapper {
      background-color: #fff;
      padding: 1rem;
      border-radius: 0.5rem;
    }

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      margin-bottom: 1rem;

      .btn {
        height: 40px;
      }
    }

    &::after {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }

    &__line {
      border-bottom: none;
    }

    th {
      text-transform: uppercase;
    }

    .row-details__container {
      padding-top: 0;
    }

    .column {
      &-check {
        width: 2.25rem;
        padding-left: 0;
      }

      &-date {
        width: 5.625rem;
      }

      &-os {
        &-content {
          color: $royal-blue;
          text-decoration: underline !important;
        }
      }

      &-material {
        &-content {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          .md-icon {
            width: 1.125rem;
            height: 1.125rem;
            min-width: auto;
            min-height: auto;
          }
        }
      }

      &-batch {
        width: 7rem;

        &-content {
          &-link {
            color: $theme-primary-color;
            text-decoration: underline;
          }
        }
      }

      &-status {
        width: 8.375rem;
      }

      &-origin {
        width: 5rem;
      }

      &-info {
        width: 3.375rem;
      }

      &-expander {
        padding-right: 0;
        width: 1.5rem;

        &-content {
          &-icon {
            transform: rotate(180deg);
            transition: transform 0.3s ease-in-out;
            color: $theme-primary-color;

            &-open {
              transform: rotate(0deg);
            }
          }
        }
      }
    }
  }

  .packaging-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.875rem;
    height: 1.875rem;
    border-radius: 100%;
    overflow: hidden;
  }

  .local-search {
    flex: 1;
    max-width: 400px;

    &-input {
      width: 100%;
      height: auto;
      font-size: 0.875rem;
      line-height: initial;
      font-family: 'Exo 2', sans-serif;

      &-container {
        width: 100%;
        height: 40px;
        min-height: auto;
        margin: 0;
        border: 1px solid #CCCCCC;
        padding: 0 8px;
        border-radius: 0.25rem;

        &::after {
          display: none;
        }
      }

      &-icon {
        width: 1.5rem;
        height: 1.5rem;
        min-width: auto;
        min-height: auto;
        position: relative;
        top: 3px;
      }
    }
  }

  .status-fail {
    color: $siren;
  }
}

.data-table-header {
  border-bottom: 2px solid #7A7A7A;
}

.styled-checkbox input[type=checkbox]:checked + label {
  background-color: $theme-primary-color;
  border: 1px solid $theme-primary-color;
}

::v-deep(.md-input-container .md-icon) {
  color: $theme-primary-color !important;
}
</style>
